import LEVELS from './levels';

const TEST_LEVELS = {
    TEST_LEVEL_1: {
      ...LEVELS.LEVEL_1,
      ID: "test_level_1",
      LEVEL_NAME: "Basic Test Level",
      VERSION: "1.0",
      IS_TEST: true,
      BOARD_SIZE: 5,
      TIME_LIMIT: 10,
      POWER_UPS_ENABLED: true,
    },
    TEST_LEVEL_2: {
      ...LEVELS.LEVEL_1,
      ID: "test_level_2",
      LEVEL_NAME: "Test Level Many PowerUps",
      VERSION: "1.0",
      IS_TEST: true,
      BOARD_SIZE: 5,
      TIME_LIMIT: 30,
      POWER_UPS_ENABLED: true,
      BOARD_INITIAL_STATE: [/* row 0 */ 7, 2, 7, 2, 7, /* row 1 */ 2, 7, 2, 7, 2, /* row 2 */ 7, 2, 7, 2, 7, /* row 3 */ 2, 7, 2, 7, 2, /* row 4 */ 7, 2, 7, 2, 7],
    },
    TEST_LEVEL_3: {
      ...LEVELS.LEVEL_5,
      ID: "test_nakamigo_crush",
      LEVEL_NAME: "Test Nakamigo Crush",
      VERSION: "1.0",
      IS_TEST: true,
      BOARD_SIZE: 5,
      TIME_LIMIT: 30,
      POWER_UPS_ENABLED: true,
      BOARD_INITIAL_STATE: [/* row 0 */ 7, 2, 7, 2, 7, /* row 1 */ 2, 7, 2, 7, 2, /* row 2 */ 7, 2, 7, 2, 7, /* row 3 */ 2, 7, 2, 7, 2, /* row 4 */ 7, 2, 7, 2, 7],
    },
    // Autoplay stress test level - only visible on localhost
    // Based on mfersbeheaded stability testing strategy
    // See docs/MFERSBEHEADED_TESTING_STRATEGY.md
    AUTOPLAY_STRESS_TEST_LEVEL_013: {
      ...LEVELS.LEVEL_1,
      ID: "autoplay_stress_test_level_013",
      LEVEL_NAME: "Mfers Just Getting Automated (Stress Test)",
      VERSION: "1.0",
      IS_TEST: true,
      AUTOPLAY: true,
      AUTOPLAY_INTERVAL_MS: 100, // Super fast (100ms) to stress test race conditions
      TIME_LIMIT: 20, // 20 second test
      POWER_UPS_ENABLED: true, // Test power-up interactions under stress
      BOARD_SIZE: 8,
      // This level is designed to:
      // - Trigger rapid successive swaps (as fast as 100ms intervals)
      // - Find valid swaps automatically (using findSwapForMatch)
      // - Play continuously without human intervention
      // - Expose potential race conditions in async operations
      // - Stress test event recording and replay system
      // - Test cascade performance under rapid gameplay
    },
  };

  export default TEST_LEVELS;
  